
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import MemberRow from "./MemberRow";
import { Member, FriendRequest } from "../types";

interface MembersTableProps {
  members: Member[];
  friendRequests: FriendRequest[];
  userId: string | undefined;
  isAdmin: boolean;
  onSendRequest: (recipientId: string) => void;
  onAcceptRequest: (requesterId: string) => void;
}

const MembersTable = ({
  members,
  friendRequests,
  userId,
  isAdmin,
  onSendRequest,
  onAcceptRequest
}: MembersTableProps) => {
  
  // Helper function to check relationship status
  const isFriend = (memberId: string): boolean => {
    return friendRequests.some(req => 
      req.status === 'accepted' && 
      ((req.requester_id === userId && req.recipient_id === memberId) || 
       (req.recipient_id === userId && req.requester_id === memberId))
    );
  };
  
  const isPendingFriend = (memberId: string): boolean => {
    return friendRequests.some(req => 
      req.status === 'pending' && 
      req.requester_id === userId && 
      req.recipient_id === memberId
    );
  };
  
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead className="hidden md:table-cell">State</TableHead>
          <TableHead className="hidden lg:table-cell">LGA</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {members.map(member => (
          <MemberRow
            key={member.id}
            member={member}
            userId={userId}
            isFriend={isFriend(member.id)}
            isPendingFriend={isPendingFriend(member.id)}
            isAdmin={isAdmin}
            onSendRequest={onSendRequest}
            onAcceptRequest={onAcceptRequest}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default MembersTable;
